package com.essntl.features.country.ui.addeditcountry

import core.validation.Form
import core.validation.field.Field
import core.validation.field.StringField
import core.validation.validator.NonEmptyValidator

class AddEditCountryValidation {
    val addEditCountryForm = AddEditCountryForm()
}

class AddEditCountryForm : Form() {
    val name =
        StringField(NonEmptyValidator)

    override val fields: List<Field> =
        listOf(name)
}